(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var mainImg = carousel.querySelector('.snack-carousel__main-img');
    var thumbs  = carousel.querySelectorAll('.snack-carousel__thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.classList.contains('is-active')) return;

        var nextSrc = thumb.dataset.src;
        var nextAlt = thumb.dataset.alt;

        mainImg.classList.add('is-switching');

        setTimeout(function () {
          mainImg.src = nextSrc;
          mainImg.alt = nextAlt;
          mainImg.classList.remove('is-switching');
        }, 150);

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}());
